import axios from 'axios';

const BASE = '/produccion/recetas';

export default {
  index() {
    return axios.get(BASE);
  },
  show(id) {
    return axios.get(`${BASE}/${id}`);
  },
  create(data) {
    return axios.post(BASE, data);
  },
  update(id, data) {
    return axios.put(`${BASE}/${id}`, data);
  },
  destroy(id) {
    return axios.delete(`${BASE}/${id}`);
  },
};
